import React from "react"

const SVG = ({
  fill = '#000',
  fillOpacity = '1',
  width = '100%',
  className = '',
  viewBox = '0 0 100 90'
}) => (
  <svg
    width={width}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      fillOpacity={fillOpacity}
      d='M33.0063583,54.3066633 L28.708511,58.6045105 C28.3115963,59.0014253 28.3116562,59.6338697 28.701773,60.0239865 L29.4103554,60.7325689 C29.8037162,61.1259297 30.4359932,61.119669 30.8298314,60.7258308 L63.5457529,28.0099093 C63.9426677,27.6129945 63.9426078,26.9805501 63.552491,26.5904333 L62.8439086,25.8818509 C62.4505478,25.48849 61.8182707,25.4947508 61.4244326,25.8885889 L55.3130215,32 L35.995404,32 C35.995404,32 32.995404,32 32.995404,35 L32.995404,54 C32.995404,54.1059165 32.9991434,54.2080936 33.0063583,54.3066633 Z M66,40 L66,48 L74,53 L74,35 L66,40 Z M62.3539452,33 C62.728515,33.4361938 62.995404,34.0577885 62.995404,34.9435876 C62.995404,34.9435875 62.995404,53.9517846 62.995404,53.9517848 C62.995404,56.9737649 59.995404,56.9737649 59.995404,56.9737649 L38.3801803,56.9737649 L62.3539452,33 L62.3539452,33 Z'
    />
  </svg>
)

export default SVG